import * as React from 'react'
import MUIAlert from '@mui/material/Alert'

const Alert = ({ variant = 'filled', ...props }) => <MUIAlert variant={variant} {...props} />

export default Alert
